/*
  Tiroir panier modulaire (thème REFONTE) — assets/pp-cart-drawer.js
  Chargé en "defer" juste AVANT theme.js. Raison : theme.js initialise les
  sections (donc new theme.CartDrawer() et sa première construction du panier)
  pendant sa propre exécution, car document.readyState vaut déjà "interactive"
  quand les scripts defer s'exécutent. On pose donc un accesseur sur
  theme.CartDrawer : dès que theme.js l'affecte, son prototype est surchargé,
  avant toute instanciation.
  Le contenu du tiroir vient de la section statique "pp-cart-drawer"
  (Section Rendering API), injectée dans #CartContainer.
*/
(function () {
  'use strict';

  var SECTION = 'pp-cart-drawer';
  var WRAPPER_ID = 'shopify-section-' + SECTION;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var state = {
    instance: null,      // instance theme.CartDrawer
    firstBuild: true,
    queue: Promise.resolve(),
    noteTimer: null
  };

  /* ---------- utilitaires DOM ---------- */

  function getContainer() {
    return (state.instance && state.instance.container && document.contains(state.instance.container))
      ? state.instance.container
      : document.getElementById('CartContainer');
  }

  function getWrapper() {
    return document.getElementById(WRAPPER_ID);
  }

  // Déplace le conteneur de section (#shopify-section-pp-cart-drawer) dans #CartContainer.
  // On déplace le conteneur entier pour que l'éditeur de thème le retrouve et le
  // remplace sur place à chaque modification (shopify:section:load).
  function mountWrapper() {
    var wrapper = getWrapper();
    var container = getContainer();
    if (!wrapper || !container) return null;
    if (wrapper.parentNode !== container) {
      container.innerHTML = '';
      container.appendChild(wrapper);
    }
    var source = document.getElementById('PpCartDrawerSource');
    if (source && !source.children.length) source.setAttribute('aria-hidden', 'true');
    applyTitle();
    return wrapper;
  }

  // Titre de l'en-tête du tiroir (snippet cart-drawer) : réglage « Titre du tiroir » de la section.
  function applyTitle() {
    var root = document.querySelector('#' + WRAPPER_ID + ' [data-pp-cd-title]');
    var title = document.querySelector('#CartDrawer .drawer__title');
    if (!root || !title) return;
    var t = root.getAttribute('data-pp-cd-title');
    if (!title.hasAttribute('data-pp-default-title')) title.setAttribute('data-pp-default-title', title.textContent.trim());
    title.textContent = '';
    var label = document.createElement('span');
    label.className = 'pp-cd-title__text';
    label.textContent = t ? t : title.getAttribute('data-pp-default-title');
    title.appendChild(label);
    var logo = root.getAttribute('data-pp-cd-logo');
    if (logo) {
      title.classList.add('pp-cd-title');
      var sep = document.createElement('span');
      sep.className = 'pp-cd-title__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '|';
      var img = document.createElement('img');
      img.className = 'pp-cd-title__logo';
      img.src = logo;
      img.alt = root.getAttribute('data-pp-cd-logo-alt') || '';
      title.appendChild(sep);
      title.appendChild(img);
    } else {
      title.classList.remove('pp-cd-title');
    }
  }

  function parseSection(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.getElementById(WRAPPER_ID);
  }

  // Remplace le contenu du tiroir par le HTML de section reçu.
  function renderSection(html) {
    var fresh = parseSection(html);
    if (!fresh) return false;
    var container = getContainer();
    if (!container) return false;

    var current = getWrapper();
    var scroller = current && current.querySelector('.drawer__scrollable');
    var scrollTop = scroller ? scroller.scrollTop : 0;
    var focusKey = document.activeElement && current && current.contains(document.activeElement)
      ? document.activeElement.getAttribute('data-pp-focus')
      : null;

    if (current && current.parentNode === container) {
      current.innerHTML = fresh.innerHTML;
    } else {
      if (current) current.remove();
      container.innerHTML = '';
      container.appendChild(document.importNode(fresh, true));
    }

    var wrapper = getWrapper();
    var newScroller = wrapper.querySelector('.drawer__scrollable');
    if (newScroller) newScroller.scrollTop = scrollTop;

    if (focusKey) {
      var target = wrapper.querySelector('[data-pp-focus="' + focusKey + '"]');
      if (!target) {
        // Ligne supprimée : on évite de donner le focus à un champ (clavier mobile).
        target = document.querySelector('#CartDrawer .js-drawer-close');
      }
      if (target) target.focus({ preventScroll: true });
    }
    applyTitle();
    return true;
  }

  /* ---------- suggestions (section cart-upsell) ---------- */

  function upsellHtml() {
    try {
      if (typeof buildCartUpsell !== 'function') return '';
      return buildCartUpsell() || '';
    } catch (e) {
      return '';
    }
  }

  function appendHtml(target, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    Array.prototype.slice.call(doc.body.childNodes).forEach(function (node) {
      target.appendChild(document.importNode(node, true));
    });
  }

  function mountUpsell() {
    var wrapper = getWrapper();
    if (!wrapper) return;
    var html = upsellHtml();
    var slot = wrapper.querySelector('[data-pp-upsell]');
    var ghost = document.getElementById('PpCartUpsellGhost');
    if (ghost) ghost.remove();

    if (slot) {
      var block = slot.closest('.pp-cd-block');
      if (html) {
        // Le tiroir est dans un <form> : innerHTML supprimerait les <form>
        // imbriqués du carrousel (sélecteurs de variante). On passe par
        // DOMParser + appendChild, comme le faisait theme.js.
        slot.innerHTML = '';
        appendHtml(slot, html);
      } else if (!(window.Shopify && Shopify.designMode)) {
        // Section cart-upsell désactivée : le bloc ne rend rien.
        if (block) block.remove();
      }
    } else if (html) {
      // Pas de bloc Suggestions : la section cart-upsell surveille quand même
      // ses éléments (#observable-…, #dot-…) chaque seconde. On les garde dans
      // un conteneur masqué pour éviter des erreurs JS.
      ghost = document.createElement('div');
      ghost.id = 'PpCartUpsellGhost';
      ghost.hidden = true;
      ghost.setAttribute('aria-hidden', 'true');
      appendHtml(ghost, html);
      (getContainer() || document.body).appendChild(ghost);
    }

    if (html) {
      try {
        if (typeof lsScroll === 'function') lsScroll('reset');
        if (typeof mountCartUpsellCarousel === 'function') mountCartUpsellCarousel();
      } catch (e) { /* section cart-upsell absente */ }
    }
  }

  /* ---------- après chaque rendu ---------- */

  // Pastille du panier (en-tête) : nombre d'articles affiché dans l'icône
  function updateBubble(count) {
    var bubble = document.getElementById('CartBubble');
    if (!bubble) return;
    count = parseInt(count, 10) || 0;
    bubble.classList.toggle('cart-link__bubble--visible', count > 0);
    bubble.textContent = count > 0 ? (count > 99 ? '99+' : String(count)) : '';
    var link = bubble.closest('.cart-link');
    if (link) link.classList.toggle('pp-cart-link--filled', count > 0);
  }

  function afterRender(cart) {
    mountUpsell();
    updateArrows();
    var wrapper = getWrapper();
    var rootEl = wrapper && wrapper.querySelector('[data-pp-cart-drawer]');
    var count = cart ? cart.item_count : (rootEl ? parseInt(rootEl.getAttribute('data-item-count'), 10) || 0 : 0);
    updateBubble(count);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      try { Shopify.StorefrontExpressButtons.initialize(); } catch (e) {}
    }
    if (cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }
  }

  function setLoading(on) {
    var drawer = state.instance;
    if (drawer && typeof drawer.loading === 'function') {
      drawer.loading(on);
    } else {
      var c = getContainer();
      if (c) c.classList.toggle('is-loading', on);
    }
  }

  /* ---------- appels réseau ---------- */

  function fetchSection() {
    return fetch(root + '?sections=' + SECTION + '&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data[SECTION]; });
  }

  function postCart(url, payload) {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || 'Erreur panier');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  // Les mises à jour sont mises en file pour garder l'ordre des clics rapides.
  function enqueue(task) {
    state.queue = state.queue.then(task, task);
    return state.queue;
  }

  function changeLine(key, quantity, lineEl) {
    return enqueue(function () {
      setLoading(true);
      if (lineEl && quantity === 0) lineEl.classList.add('is-removing');
      return postCart('cart/change.js', { id: key, quantity: quantity })
        .then(function (cart) {
          var html = cart.sections && cart.sections[SECTION];
          if (html) {
            renderSection(html);
            afterRender(cart);
          } else {
            return fetchSection().then(function (h) { renderSection(h); afterRender(cart); });
          }
        })
        .catch(function (err) {
          // Ex. stock insuffisant (422) : on re-rend puis on affiche le message sur la ligne.
          return fetchSection().then(function (h) {
            renderSection(h);
            afterRender(null);
            var wrapper = getWrapper();
            var line = wrapper && wrapper.querySelector('.pp-cd-line[data-pp-line-key="' + cssEscape(key) + '"]');
            var box = line && line.querySelector('.pp-cd-line__error');
            if (box) {
              box.textContent = err.message;
              box.hidden = false;
            }
          });
        })
        .then(function () { setLoading(false); }, function () { setLoading(false); });
    });
  }

  function saveNote(value) {
    return enqueue(function () {
      return postCart('cart/update.js', { note: value }).catch(function () {});
    });
  }

  function cssEscape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/"/g, '\\"');
  }

  /* ---------- interactions dans le tiroir ---------- */

  function onClick(evt) {
    var btn = evt.target.closest('[data-pp-qty]');
    if (!btn || !btn.closest('#' + WRAPPER_ID)) return;
    evt.preventDefault();
    var line = btn.closest('.pp-cd-line');
    if (!line) return;
    var qty = Math.max(0, parseInt(btn.getAttribute('data-pp-qty'), 10) || 0);
    changeLine(line.getAttribute('data-pp-line-key'), qty, line);
  }

  function onChange(evt) {
    var input = evt.target;
    if (!input.closest || !input.closest('#' + WRAPPER_ID)) return;
    if (input.hasAttribute('data-pp-qty-input')) {
      var line = input.closest('.pp-cd-line');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeLine(line.getAttribute('data-pp-line-key'), qty, line);
    } else if (input.hasAttribute('data-pp-note')) {
      clearTimeout(state.noteTimer);
      saveNote(input.value);
    }
  }

  function onInput(evt) {
    var input = evt.target;
    if (!input.hasAttribute || !input.hasAttribute('data-pp-note') || !input.closest('#' + WRAPPER_ID)) return;
    clearTimeout(state.noteTimer);
    state.noteTimer = setTimeout(function () { saveNote(input.value); }, 800);
  }

  function onKeydown(evt) {
    // Entrée dans le champ quantité : met à jour au lieu de soumettre le formulaire (paiement).
    if (evt.key === 'Enter' && evt.target.hasAttribute && evt.target.hasAttribute('data-pp-qty-input')) {
      evt.preventDefault();
      evt.target.blur();
    }
  }

  /* ---------- suggestions selon le panier (bloc dynamic_upsell) ---------- */

  function fetchCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function setBtnLoading(btn, on) {
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  function addUpsell(btn) {
    var card = btn.closest('[data-pp-upsell-card]');
    if (!card || btn.disabled) return;
    var select = card.querySelector('[data-pp-upsell-variant]');
    var id = parseInt(select ? select.value : btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var errBox = card.querySelector('.pp-cdu__error');
    if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
    setBtnLoading(btn, true);
    return enqueue(function () {
      setLoading(true);
      return postCart('cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function (res) {
          var html = res && res.sections && res.sections[SECTION];
          return (html ? Promise.resolve(html) : fetchSection()).then(function (h) {
            renderSection(h);
            return fetchCart().then(function (cart) { afterRender(cart); }, function () { afterRender(null); });
          });
        })
        .catch(function (err) {
          // Ex. 422 (stock insuffisant) : le panier n'a pas changé, message sous la carte.
          setBtnLoading(btn, false);
          if (errBox && document.contains(errBox)) {
            errBox.textContent = err.message || 'Impossible d\'ajouter ce produit.';
            errBox.hidden = false;
          }
        })
        .then(function () { setLoading(false); }, function () { setLoading(false); });
    });
  }

  // Indicateur de défilement des suggestions (points ou barre), surtout pour le mobile
  function updateIndicator(box, track, max) {
    var ind = box && box.querySelector('[data-pp-upsell-ind]');
    if (!ind) return;
    ind.classList.toggle('is-hidden', track.clientWidth > 0 && max <= 1);
    var cards = track.querySelectorAll('[data-pp-upsell-card]');
    var dots = ind.querySelectorAll('.pp-cdu__dot');
    if (dots.length) {
      var active = 0, best = Infinity;
      Array.prototype.forEach.call(cards, function (card, i) {
        var d = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < best) { best = d; active = i; }
      });
      if (max > 1 && track.scrollLeft >= max - 1) active = cards.length - 1;
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.hidden = i >= cards.length;
        dot.classList.toggle('is-active', i === active);
      });
    }
    var fill = ind.querySelector('.pp-cdu__bar-fill');
    if (fill && track.scrollWidth > 0) {
      fill.style.width = (track.clientWidth / track.scrollWidth * 100) + '%';
      fill.style.left = (track.scrollLeft / track.scrollWidth * 100) + '%';
    }
  }

  function updateArrows(scope) {
    var tracks = (scope || document).querySelectorAll('#' + WRAPPER_ID + ' .pp-cdu:not(.pp-cdu--list) [data-pp-upsell-track]');
    Array.prototype.forEach.call(tracks, function (track) {
      var box = track.closest('.pp-cdu');
      // Tiroir encore masqué : mesures nulles, on garde l'état initial (suivant actif)
      if (!track.clientWidth) return;
      var max = track.scrollWidth - track.clientWidth;
      updateIndicator(box, track, max);
      var arrows = box && box.querySelector('[data-pp-upsell-arrows]');
      if (!arrows) return;
      arrows.classList.toggle('is-hidden', track.clientWidth > 0 && max <= 1);
      var prev = arrows.querySelector('[data-pp-upsell-scroll="-1"]');
      var next = arrows.querySelector('[data-pp-upsell-scroll="1"]');
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    });
  }

  function onUpsellClick(evt) {
    var add = evt.target.closest('[data-pp-upsell-add]');
    if (add && add.closest('#' + WRAPPER_ID)) {
      evt.preventDefault();
      addUpsell(add);
      return;
    }
    var arrow = evt.target.closest('[data-pp-upsell-scroll]');
    if (arrow && arrow.closest('#' + WRAPPER_ID)) {
      evt.preventDefault();
      var box = arrow.closest('.pp-cdu');
      var track = box && box.querySelector('[data-pp-upsell-track]');
      if (!track) return;
      var dir = parseInt(arrow.getAttribute('data-pp-upsell-scroll'), 10) || 1;
      track.scrollBy({ left: dir * Math.max(120, track.clientWidth * 0.8), behavior: 'smooth' });
    }
  }

  function onUpsellChange(evt) {
    var select = evt.target;
    if (!select.hasAttribute || !select.hasAttribute('data-pp-upsell-variant')) return;
    var card = select.closest('[data-pp-upsell-card]');
    var opt = select.options[select.selectedIndex];
    var priceBox = card && card.querySelector('[data-pp-upsell-price]');
    if (!opt || !priceBox) return;
    priceBox.textContent = '';
    var compare = opt.getAttribute('data-compare');
    if (compare) {
      var s = document.createElement('s');
      s.className = 'pp-cdu__compare';
      s.textContent = compare;
      priceBox.appendChild(s);
      priceBox.appendChild(document.createTextNode(' '));
    }
    var span = document.createElement('span');
    span.className = 'pp-cdu__final';
    span.textContent = opt.getAttribute('data-price') || '';
    priceBox.appendChild(span);
    var btn = card.querySelector('[data-pp-upsell-add]');
    if (btn) btn.setAttribute('data-variant-id', select.value);
  }

  document.addEventListener('click', onUpsellClick);
  document.addEventListener('change', onUpsellChange);
  document.addEventListener('scroll', function (evt) {
    var t = evt.target;
    if (t && t.hasAttribute && t.hasAttribute('data-pp-upsell-track')) updateArrows();
  }, true);
  window.addEventListener('resize', function () { updateArrows(); });

  document.addEventListener('click', onClick);
  document.addEventListener('change', onChange);
  document.addEventListener('input', onInput);
  document.addEventListener('keydown', onKeydown);

  /* ---------- surcharge de theme.CartDrawer ---------- */

  function buildCart(cart, openDrawer, returnFocusEl) {
    var self = this;
    state.instance = self;

    var first = state.firstBuild;
    state.firstBuild = false;

    var wrapper = getWrapper();
    var serverRoot = wrapper && wrapper.querySelector('[data-pp-cart-drawer]');
    var upToDate = first && serverRoot && cart &&
      String(cart.item_count) === serverRoot.getAttribute('data-item-count') &&
      String(cart.total_price) === serverRoot.getAttribute('data-total');

    self.loading(true);
    var job = upToDate
      ? Promise.resolve(null)
      : fetchSection();

    return job.then(function (html) {
      if (html) {
        renderSection(html);
      } else {
        mountWrapper();
      }
      afterRender(cart);
      self.status.loaded = true;
      self.loading(false);
      if (openDrawer === true) {
        self.drawer.open(false, returnFocusEl);
      }
      setTimeout(updateArrows, 400);
    }).catch(function (e) {
      self.loading(false);
      mountWrapper();
      if (openDrawer === true) self.drawer.open(false, returnFocusEl);
      if (window.console) console.error('[pp-cart-drawer]', e);
    });
  }

  function patchProto(Ctor) {
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__ppPatched) return;
    Ctor.prototype.buildCart = buildCart;
    Ctor.prototype.updateSuccess = function () {
      return fetchSection().then(function (h) { renderSection(h); afterRender(null); });
    };
    // Les sélecteurs de quantité du thème ne servent plus (contrôles propres au tiroir).
    Ctor.prototype.initQtySelectors = function () {};
    Ctor.prototype.__ppPatched = true;
  }

  window.theme = window.theme || {};
  if (theme.CartDrawer) {
    // Script chargé après theme.js : la première construction a déjà eu lieu
    // avec le gabarit d'origine, on surcharge puis on reconstruit.
    patchProto(theme.CartDrawer);
    document.addEventListener('DOMContentLoaded', function () {
      if (getContainer()) fetchSection().then(function (h) { renderSection(h); afterRender(null); });
    });
  } else {
    var cartDrawerCtor;
    Object.defineProperty(theme, 'CartDrawer', {
      configurable: true,
      enumerable: true,
      get: function () { return cartDrawerCtor; },
      set: function (v) {
        cartDrawerCtor = v;
        try { patchProto(v); } catch (e) { if (window.console) console.error('[pp-cart-drawer]', e); }
      }
    });
  }

  /* ---------- éditeur de thème ---------- */

  function isOurSection(evt) {
    return evt && evt.detail && evt.detail.sectionId === SECTION;
  }

  function openDrawer() {
    if (state.instance && state.instance.drawer && !state.instance.drawer.isOpen) {
      state.instance.drawer.open();
    }
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (!isOurSection(evt)) return;
    mountWrapper();
    afterRender(null);
    openDrawer();
  });

  document.addEventListener('shopify:section:select', function (evt) {
    if (isOurSection(evt)) openDrawer();
  });

  document.addEventListener('shopify:block:select', function (evt) {
    if (isOurSection(evt)) openDrawer();
  });

  // Recalcule flèches et indicateur dès que le tiroir devient visible ou change de taille
  (function watchDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        updateArrows();
        setTimeout(updateArrows, 350);
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    if (window.ResizeObserver && drawer) {
      new ResizeObserver(function () { updateArrows(); }).observe(drawer);
    }
  })();

  // Compteur de l'icône panier dès le chargement de la page
  (function initBubble() {
    var root = document.querySelector('[data-pp-cart-drawer][data-item-count]');
    if (root) updateBubble(root.getAttribute('data-item-count'));
  })();

  window.ppCartDrawer = {
    refresh: function () {
      return fetchSection().then(function (h) { renderSection(h); afterRender(null); });
    },
    change: changeLine
  };
})();
